import { apiClient } from '@/api/apiClient';
import endpoints from './endpoints';

export default {
  getReservations: async (params) => await apiClient.get(endpoints.getAll(), { params }),
  getReservationById: async (id) => await apiClient.get(endpoints.getById(id)),
  createReservation: async (data) => await apiClient.post(endpoints.create(), data),
  updateReservation: async ({ id, ...data }) => await apiClient.put(endpoints.update(id), data),
  deleteReservation: async (id) => await apiClient.delete(endpoints.delete(id)),
  getEligibleStatements: async (id, params) => await apiClient.get(endpoints.getEligibleStatements(id), { params }),
  deferReservation: async ({ id, ...data }) => await apiClient.post(endpoints.defer(id), data),
};
